import { render, staticRenderFns } from "./BaseDataGrid.vue?vue&type=template&id=550d05ba&"
import script from "./BaseDataGrid.vue?vue&type=script&lang=js&"
export * from "./BaseDataGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports